import { decodeString } from 'use-query-params';

function transformString(
  str: string | null | undefined,
): string | null | undefined {
  if (str === '') {
    return undefined;
  }

  if (str == null) {
    return str;
  }

  return String(str);
}

const CustomStringParam = {
  encode: transformString,
  decode: decodeString,
};

export default CustomStringParam;
